import type { ReceiptTemplate } from '../schema';

export const squareTemplate: ReceiptTemplate = {
  id: 'square',
  name: 'Square Receipt',
  brand: 'SQUARE',
  description: 'Square payment receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'square-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'MONSTERVILLE SHOP',
        businessNameFontSize: 16,
        addressLines: [
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'square-datetime',
      type: 'datetime',
      enabled: true,
      config: {
        alignment: 'center',
        dateTime: new Date().toISOString(), format: 'MM/DD/YYYY hh:mm A',
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'square-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'COFFEE LATTE', quantity: '1', price: '5.50', sku: '' },
          { id: '2', name: 'MUFFIN BLUEBERRY', quantity: '1', price: '3.75', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'square-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '9.25', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '0.76', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '10.01', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'square-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [
          { id: 'auth', label: 'Auth:', value: '059746' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'square-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Powered by Square\n\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

